export default function checkStatusInUse({ postData }) {
  return {
    success: true,
    isApp: false,
    statusInUse: true,
  };
}
